export default {"src":"https://filecdn-other.xingyeai.com/xingye-ugc/_next/static/media/info.3876cd90.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};